export const SIMPLE = "SIMPLE";
export const ASOSIY = "ASOSIY";
export const SERVICES = "SERVICES";
export const HISOBOT = "HISOBOT";
